(function(arc, $) {

  // only generate the notification centre if the user is logged in and they're
  // using the new topix features.
  if (userLoggedIn) {
    arc.notificationCentre();
  }

})(arc, jQuery);
